import type { BuildingSocietySavingsOverviewCountryConfig } from '../../BuildingSocietySavingsOverviewConfig';

export const savingsOverview: BuildingSocietySavingsOverviewCountryConfig = {
    showAdjustableOverview: true,
    showTargetAmount: true,
    highlights: {
        displayExpiryDate: true,
    },
    list: {
        displayContractHolders: true,
        displayTargetAmount: true,
        displayIbanAndBic: true,
        displayBonusBearingMonthlySavings: true,
        displayBonusBearingDepositDone: true,
        displayBonusBearingDepositToPay: true,
        displayNotRequestedBonus: true,
    },
};
